(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
/* Publishes the bar's height so the floating header and every page band can
   move down by exactly that much. Measured rather than assumed, because the
   text wraps to two lines on a narrow phone. */
(function () {
  function publish() {
    var bar = document.querySelector('[data-gy-announce]');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--gy-announce-h', h + 'px');
    document.dispatchEvent(new CustomEvent('gy:announce-resize', { detail: { height: h } }));
  }

  function init() {
    var bar = document.querySelector('[data-gy-announce]');
    if (!bar) {
      document.documentElement.style.setProperty('--gy-announce-h', '0px');
      return;
    }

    if (bar.dataset.gyReady === '1') { publish(); return; }
    bar.dataset.gyReady = '1';

    var key = 'gy-announce-dismissed';
    var stamp = bar.getAttribute('data-gy-announce') || '';
    var close = bar.querySelector('[data-gy-announce-close]');

    if (close) {
      var seen = null;
      try { seen = window.localStorage.getItem(key); } catch (e) { seen = null; }
      /* Storage can throw in a private window and can come back empty; either
         way the bar simply shows, which is the safe direction. */
      if (seen !== null && seen === stamp) {
        bar.remove();
        publish();
        return;
      }
      close.addEventListener('click', function () {
        bar.remove();
        try { window.localStorage.setItem(key, stamp); } catch (e) {}
        publish();
      });
    }

    publish();
    if (window.ResizeObserver) { new ResizeObserver(publish).observe(bar); }
    else { window.addEventListener('resize', publish, { passive: true }); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', publish);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
/* The cookie-settings affordance, when it is switched on. Shopify's own privacy
   banner owns consent on this platform, and there is no universal API to reopen
   it, so this raises an event for whichever banner the store ends up using
   rather than pretending to do the job itself. */
(function () {
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-gy-cookie-settings]')) { return; }
    document.dispatchEvent(new CustomEvent('gy:cookie-settings', { bubbles: true }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* ===========================================================================
   The sticky bar, and the height it publishes.
   That is all this file does. The drawer, the search overlay and the sliding
   menu panels are run by the controllers already in assets/theme.js, through
   their markup contracts; duplicating them here would be a second
   implementation of the same thing waiting to drift.
   =========================================================================== */
(function () {
  'use strict';

  var H = null;      /* whichever header is currently mounted */
  var bound = false; /* window/document listeners are registered once */

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Every page band pads itself by --gy-header-h. It is measured rather than
     assumed, because the logo's own aspect decides the bar's height and an
     announcement bar above it changes the total. If this never runs, the value
     in assets/theme.css (103px, 72px below 1190) is already right. */
  function measure() {
    if (!H || !H.bar || H.root.classList.contains('is-stuck')) { return; }
    H.barHeight = Math.round(H.bar.getBoundingClientRect().height);
    var announced = getComputedStyle(document.documentElement)
      .getPropertyValue('--gy-announce-h');
    H.announceHeight = parseFloat(announced) || 0;
    document.documentElement.style.setProperty(
      '--gy-header-h', (H.barHeight + H.announceHeight) + 'px'
    );
  }

  /* A threshold, not a hide-on-scroll-down: the bar appears once the floating
     one has gone, and leaves again at the top of the page. */
  function onScroll() {
    if (!H || !H.sticky || !H.bar) { return; }
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var trigger = H.barHeight + H.announceHeight;

    if (!H.stuck && y >= trigger) {
      H.stuck = true;
      H.root.classList.add('is-stuck');
      if (reduced()) {
        H.root.classList.add('is-shown');
      } else {
        /* Two frames. One, and the browser coalesces the parked state with the
           shown state and nothing animates. */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (H && H.stuck) { H.root.classList.add('is-shown'); }
          });
        });
      }
    } else if (H.stuck && y < trigger) {
      H.stuck = false;
      H.root.classList.remove('is-shown');
      H.root.classList.remove('is-stuck');
    }
  }

  var ticking = false;
  function queueScroll() {
    if (ticking) { return; }
    ticking = true;
    requestAnimationFrame(function () { ticking = false; onScroll(); });
  }

  function bindOnce() {
    if (bound) { return; }
    bound = true;

    window.addEventListener('scroll', queueScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    window.addEventListener('load', function () { measure(); onScroll(); });
    document.addEventListener('gy:announce-resize', function () { measure(); onScroll(); });

    /* Escape closes the desktop dropdown. It is held open by :focus-within, so
       moving focus back to the parent link is what closes it — there is no
       state to unset. The WordPress original is hover-only and cannot offer
       this at all. Skipped while a drawer is open; that Escape is the drawer's. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') { return; }
      if (document.querySelector('.gy-drawer.is-open')) { return; }
      var active = document.activeElement;
      if (!active || !active.closest) { return; }
      var item = active.closest('.gy-nav__item--has-children');
      if (!item) { return; }
      var parentLink = item.querySelector('.gy-nav__link');
      if (parentLink) { parentLink.focus(); }
    });
  }

  function init() {
    var root = document.querySelector('[data-gy-header]');
    if (!root) { H = null; return; }

    H = {
      root: root,
      bar: root.querySelector('[data-gy-bar]'),
      sticky: root.getAttribute('data-sticky') === 'true',
      barHeight: 0,
      announceHeight: 0,
      stuck: false
    };

    bindOnce();
    measure();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor: the section's DOM is replaced, so point at the new one. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector &&
        event.target.querySelector('[data-gy-header]')) { init(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
